import { PageContentNotifications } from '@restaurant/core'
import { useWebNotificationsPageViewModel } from '../viewmodels/pages/WebNotificationsPageViewModel'

export default function NotificationsPage() {
  const viewModel = useWebNotificationsPageViewModel()
  const pageProps = viewModel.getPageContentNotificationsProps()

  return (
    <PageContentNotifications
      {...pageProps}
      testID="notifications-page"
      accessibilityLabel="Manage your notification preferences"
    />
  )
}
